import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { gtmPush, ordenarEtiquetas } from '@/utils';
import {
    AddDiscountToCart,
    ReadCart,
    RemoveItemFromCart,
    UpdateItemFromCart,
    addItemToCart,
    newCart,
} from './utils/shopify';

import { showPopUp } from "@/lib/cartPopUp";
import { unitLimitQuantity, unitLimitTag } from './constants';
import { processUnitLimit } from './utils/utils';


export type MoneyV2 = { amount: string; currencyCode: string };

export type CartCodeDiscountAllocation = {
  __typename: 'CartCodeDiscountAllocation';
  discountedAmount: MoneyV2;
  code: string;
};

export interface CARTS {
    loading: boolean;
    error?: unknown;
    order: string;
    data: {
        cart: {
            id: string;
            createdAt: string;
            updatedAt: string;
            checkoutUrl: string;
            lines: {
                edges: {
                    node?: {
                        id: string;
                        quantity: number;
                        merchandise: {
                            id: string;
                        };
                        discountAllocations?: CartCodeDiscountAllocation[];
                    };
                }[];
            };
            attributes: {
                key?: string;
                value?: string;
            }[];
            cost: {
                totalAmount: MoneyV2;
                subtotalAmount:  MoneyV2;
                checkoutChargeAmount: MoneyV2;
                totalTaxAmount: MoneyV2 | null;
                totalDutyAmount: MoneyV2 | null;
            };
            discountAllocations: CartCodeDiscountAllocation[];
        };
    };
}

const initialState: CARTS = {
    loading: true,
    order: '#',
    data: {
        cart: {
            id: '',
            createdAt: '',
            updatedAt: '',
            checkoutUrl: '',
            lines: {
                edges: [],
            },
            attributes: [],
            cost: {
                totalAmount: {
                    amount: '0.0',
                    currencyCode: 'EUR',
                },
                subtotalAmount: {
                    amount: '75.0',
                    currencyCode: 'EUR',
                },
                checkoutChargeAmount: {
                    amount: '75.0',
                    currencyCode: 'EUR',
                },
                totalTaxAmount: null,
                totalDutyAmount: null,
            },
            discountAllocations: [],
        },
    },
};

const __loadCart = async (cartId: string) => {
    try {
        const { data } = await ReadCart(cartId);
        return data;
    } catch (error) {
        console.error('Error loading cart:', error);
        return null;
    }
};

const __createCart = async () => {
    try {
        const data = await newCart();
        return data.data.cartCreate;
    } catch (error) {
        return error;
    }
};

const __newItem = async (cartId: string, itemId: string) => {
    try {
        const data = await addItemToCart(cartId, itemId, 1);

        return data.data.cartLinesAdd;
    } catch (error) {
        return error;
    }
};

const __updateLine = async (
    cartId: string,
    lineId: string,
    itemId: string,
    quantity: number
) => {
    try {

        const data = await UpdateItemFromCart(cartId, lineId, itemId, quantity);
        return data.data.cartLinesUpdate;
    } catch (error) {
        return error;
    }
};

const __removeLine = async (cartId: string, lineId: string) => {
    try {
        const data = await RemoveItemFromCart(cartId, lineId);
        return data.data.cartLinesRemove;
    } catch (error) {
        return error;
    }
};

const __addDiscountToCart = async (cartId: string, discountCode: string) => {
    try {
        const data = await AddDiscountToCart(cartId, discountCode);
        return data.data.cartDiscountCodesUpdate;
    } catch (error) {
        return error;
    }
};

export const loadCart = createAsyncThunk('cart/load', async () => {
    const cartId = localStorage.getItem('cart') || '';
    let data;

    if (!cartId) {
        // There wasn't any cart in the local storage
        sessionStorage.removeItem('typesElements');
        data = await __createCart();
        localStorage.setItem('cart', data.cart.id);

    } else {
        // There's a cart in the local storage
        data = await __loadCart(cartId);

        if (!data.cart) {
            // This cart doesn't exist in Shopify, so we create a new one
            data = await __createCart();
            localStorage.setItem('cart', data.cart.id);
        }
    }

    return data;
});


export const addToCart = createAsyncThunk(
    'cart/add',
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async (item: any, {dispatch, getState}) => {
        //  const giftValues = item.metafields.custom?.gift?.value === 'true';
        let cartId = localStorage.getItem('cart') || '';
        //const typeElementId = localStorage.getItem('typeElements') || '';

        if (cartId === '') {
            const data = await __createCart();
            cartId = data.cart.id;
            localStorage.setItem('cart', data.cart.id);
        }
        //if (typeElementId === '') {
        //   if (giftValues) {
        //      dispatch(setTipoProducto('gift'));
        //      localStorage.setItem('typeElements', 'gift');
        //    } else {
        //     dispatch(setTipoProducto('normal'));
        //     localStorage.setItem('typeElements', 'normal');
        //   }
        //}
        const etiquetas = item ? item.tags.map((item) => (item.name)) : [];
        const {cart,totalItems} = processUnitLimit(getState)
        //descomentar
        if(totalItems < unitLimitQuantity || !item.tags.some((tag) => tag.name === unitLimitTag)){
            gtmPush({ ecommerce: null });
            gtmPush({
                event: 'add_to_cart',
                ecommerce: {
                    currency: 'EUR',
                    value: item.variants[0].price,
                    items: [
                        {
                            item_id: item.product_id,
                            item_name: item.title.toUpperCase(),
                            affiliation: 'Navidul',
                            item_brand: 'Navidul',
                            item_category: ordenarEtiquetas(etiquetas)[0][0]
                                ? ordenarEtiquetas(etiquetas)[0][0]
                                : '',
                            item_category2: ordenarEtiquetas(etiquetas)[0][1]
                                ? ordenarEtiquetas(etiquetas)[0][1]
                                : '',
                            item_category3: ordenarEtiquetas(etiquetas)[0][2]
                                ? ordenarEtiquetas(etiquetas)[0][2]
                                : '',
                            price: item.variants[0].price,
                            quantity: 1,
                            discount: item?.variants[0].compare_at_price &&
                            item?.variants[0].price
                            ? item?.variants[0].compare_at_price -
                            item?.variants[0].price
                            : 0,
                        },
                    ],
                },
            });
            const response = await __newItem(cartId, item.variants[0].variant_id);
            localStorage.setItem('cart-version', Date.now().toString());
            
            return response;
        }else{
            dispatch(showPopUp());
            return cart.data;
        }
    }
);

export const updateLineFromCart = createAsyncThunk(
    'cart/update',
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async ({ lineId, itemId, product, quantity }: any,{dispatch, getState}) => {
        const cartId = localStorage.getItem('cart') || '';

        if (cartId !== '') {
            const actualCart = await __loadCart(cartId);
            const cartAnterior = actualCart.cart.lines.edges.filter(
                (edge) => edge.node.merchandise.id === `gid://shopify/ProductVariant/${itemId}`
            );
            const {cart,totalItems} = processUnitLimit(getState);
            if(cartAnterior[0].node.quantity < quantity && product.tags.some((tag) => tag.name === unitLimitTag) && totalItems >= unitLimitQuantity){
                dispatch(showPopUp())
                return cart.data
            }
            const carts = await __updateLine(cartId, lineId, itemId, quantity);
            const cartNuevo = carts.cart.lines.edges.filter(
                (edge) => edge.node.merchandise.id === `gid://shopify/ProductVariant/${itemId}`
            );

            const etiquetas = product ? product.tags.map((item) => (item.name)) : [];
            gtmPush({ ecommerce: null });
            const absQuantity = Math.abs(
                cartAnterior[0].node.quantity - cartNuevo[0].node.quantity
            );
            gtmPush({
                event:
                    cartAnterior[0].node.quantity < cartNuevo[0].node.quantity
                        ? 'add_to_cart'
                        : 'remove_from_cart',
                ecommerce: {
                    currency: 'EUR',
                    value: (product.variants[0].price * absQuantity).toFixed(2),
                    items: [
                        {
                            item_id: product.product_id,
                            item_name: product.title.toUpperCase(),
                            affiliation: 'Navidul',
                            item_brand: 'Navidul',
                            item_category: ordenarEtiquetas(etiquetas)[0][0]
                                ? ordenarEtiquetas(etiquetas)[0][0]
                                : '',
                            item_category2: ordenarEtiquetas(etiquetas)[0][1]
                                ? ordenarEtiquetas(etiquetas)[0][1]
                                : '',
                            item_category3: ordenarEtiquetas(etiquetas)[0][2]
                                ? ordenarEtiquetas(etiquetas)[0][2]
                                : '',
                            price: product.variants[0].price,
                            quantity: absQuantity,
                            discount: product?.variants[0].compare_at_price &&
                            product?.variants[0].price
                            ? product?.variants[0].compare_at_price -
                            product?.variants[0].price
                            : 0,
                        },
                    ],
                },
            });
            localStorage.setItem('cart-version', Date.now().toString());
            return await carts;
        }
    }
);

export const addDiscountToCart = createAsyncThunk(
    "cart/addDiscount",
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async ({ discount }: any) => {

        let cartId = localStorage.getItem("cart") || "";
        if (cartId === "") {
            const data = await __createCart();
            cartId = data.cart.id;
            localStorage.setItem("cart", data.cart.id);
        }
        const cart = await __addDiscountToCart(cartId, discount);

        localStorage.setItem('cart-version', Date.now().toString());
        
        return cart;
    }
);

export const removeLineFromCart = createAsyncThunk(
    'cart/remove',
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async ({ lineId, product }: any) => {

        const cartId = localStorage.getItem('cart') || '';
        if (cartId !== '') {
            const cart = await __loadCart(cartId);
            const item = cart.cart.lines.edges.filter(
                (edge) => edge.node.id === lineId
            );
            const etiquetas = product ? product.tags.map((item) => (item.name)) : [];
            gtmPush({ ecommerce: null });
            gtmPush({
                event: 'remove_from_cart',
                currency: 'EUR',
                value: (product.variants[0].price*item[0].node.quantity).toFixed(2),
                ecommerce: {
                    items: [
                        {
                            item_id: product.product_id,
                            item_name: product.title.toUpperCase(),
                            affiliation: 'Navidul',
                            item_brand: 'Navidul',
                            item_category: ordenarEtiquetas(etiquetas)[0][0]
                                ? ordenarEtiquetas(etiquetas)[0][0]
                                : '',
                            item_category2: ordenarEtiquetas(etiquetas)[0][1]
                                ? ordenarEtiquetas(etiquetas)[0][1]
                                : '',
                            item_category3: ordenarEtiquetas(etiquetas)[0][2]
                                ? ordenarEtiquetas(etiquetas)[0][2]
                                : '',
                            price: product.variants[0].price,
                            quantity: item[0].node.quantity,
                            discount:
                                product.variants[0].compare_at_price &&
                                    product.variants[0].price
                                    ? product.variants[0].compare_at_price -
                                    product.variants[0].price
                                    : 0,
                        },
                    ],
                },
            });
            const response = await __removeLine(cartId, lineId);
            localStorage.setItem('cart-version', Date.now().toString());
            return response;
        }
    }
);

export const carts = createSlice({
    name: 'carts',
    initialState,
    extraReducers: (builder) =>{
        builder
        .addCase(loadCart.pending, (state) => {
            state.loading = true;
        })
        .addCase(loadCart.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload ? action.payload : state.data;
        })
        .addCase(loadCart.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        .addCase(addToCart.pending, (state) => {
            state.loading = true;
        })
        .addCase(addToCart.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        })
        .addCase(addToCart.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        .addCase(updateLineFromCart.pending, (state) => {
            state.loading = true;
        })
        .addCase(updateLineFromCart.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        })
        .addCase(updateLineFromCart.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        .addCase(removeLineFromCart.pending, (state) => {
            state.loading = true;
        })
        .addCase(removeLineFromCart.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        })
        .addCase(removeLineFromCart.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        .addCase(addDiscountToCart.pending, (state) => {
            state.loading = true;
        })
        .addCase(addDiscountToCart.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        })
        .addCase(addDiscountToCart.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        .addDefaultCase(() => {});
    },
    reducers: {
        clearCart: () => {
            localStorage.removeItem('cart');
            //state = initialState;
        },
    },
});

export const { clearCart } = carts.actions;

export default carts.reducer;
